import React, { useEffect, useRef, useState } from "react";

const EditAlert = ({ onClose }) => {

    return (
        <div>
            <div className="modal-backdrop show"></div>
            <div
                className="modal show"
                id="CustomerModal"
                tabIndex="0"
                aria-modal="true"
                role="dialog"
                style={{ display: "block" }}
            >
                <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-sm">
                    <div className="modal-content bg-warning">
                        <div className="modal-header border-0">
                            <h6 className="modal-title text-dark"></h6>
                            <button
                                type="button"
                                onClick={onClose}
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <h6 className="text-center text-dark">Edit Feature Alert</h6>
                            <p className="text-center text-dark mb-0">
                                Editing quantity and removing items is not allowed for this sale.
                                
                            </p>
                            <p className="text-center text-dark mb-0">However, you can change the customer if needed.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditAlert;